import { LockingSystemComponentsByUuid } from "@secureo/common/typings/LockingSystem"

const getUpdatedComponentsByUuid = (
	uuids: string[],
	prevComponentsByUuid: LockingSystemComponentsByUuid,
) => {
	const componentsByUuid = uuids.reduce((componentsByUuid, uuid) => {
		return {
			...componentsByUuid,
			[uuid]: prevComponentsByUuid[uuid],
		}
	}, {} as LockingSystemComponentsByUuid)

	return componentsByUuid
}

export default getUpdatedComponentsByUuid
